// extracted by mini-css-extract-plugin
module.exports = {"root":"PermissionsSelector_root__2ze7x","button":"PermissionsSelector_button__RqriX"};